import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import HealthInsuranceOverview from '../../../components/FormDescriptions/HealthInsuranceOverview';
import { emptyObjectSchema } from '../../../definitions';
import content from '../../../locales/en/content.json';

export default {
  uiSchema: {
    ...titleUI(content['insurance-info--overview-title']),
    ...descriptionUI(HealthInsuranceOverview),
  },
  schema: emptyObjectSchema,
};
